import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import React from "react";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import {
  ApiResponseLogCategory,
  GetApiResponseLogsQuery,
  GetApiResponseLogsQueryVariables,
} from "generated/graphql";

const useApiLogs = (logCategory: ApiResponseLogCategory) => {
  const [page, setPage] = React.useState(1);
  const rowsPerPage = parseInt(
    process.env.REACT_APP_DATA_EXCHANGE_PER_PAGE!,
    10
  );
  const { permissions } = usePartnerConfig();
  const { canShowApiLogs } = permissions;

  const { data, refetch, loading } = useQuery<
    GetApiResponseLogsQuery,
    GetApiResponseLogsQueryVariables
  >(queries.GET_API_RESPONSE_LOGS, {
    variables: {
      logCategory,
      page,
      perPage: rowsPerPage,
    },
    skip: !canShowApiLogs,
  });

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setPage(page);
  };

  React.useEffect(() => {
    if (canShowApiLogs) {
      refetch({ page });
    }
  }, [page, refetch, canShowApiLogs]);

  return { page, rowsPerPage, data, handlePageChange, loading };
};

export default useApiLogs;
